import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { isBusy, withActions } from "actionware";
import { getTranslate } from "react-localize-redux";
import { push } from "connected-react-router";

import SetupLimitCard from "./fundingLimitComponents/setupLimitCard";

import "./fundingLimit.less";
import { getProductsList, saveNewCycleData } from "./fundingLimitActions";
import { bindActionCreators } from "redux";
import { getLenderId, getRole } from "../../common/helpers";
import _ from "lodash";
import { Button, Spin } from "antd";
import {
  validateSetupLimitInputFieldsOnClickNext,
  removeInvalidMessageOnSetupLimitInputFieldChange,
} from "../fundingLimit/validations";

const SetupLimit = ({
  products,
  newCycle,
  getProductsList,
  saveNewCycleData,
  loading,
  translate,
  nextStepClicked,
}) => {
  const [productValidations, setProductValidations] = useState(new Map());

  const setValidationState = () => {
    const initialValidationState = getInitialState();
    setProductValidations(initialValidationState);
  };

  useEffect(() => {
    if (_.isEmpty(products)) {
      const params = {
        status: "pending",
      };
      getProductsList(params);
    }
    setValidationState();
  }, [products, getProductsList]);

  const goNextState = () => {
    nextStepClicked();
  };

  const getInitialState = () => {
    const productValidationsMap = new Map();
    products.forEach((product) => {
      productValidationsMap.set(product.code, {
        isInvalidInput: false,
        invalidInputMessage: "",
      });
    });
    return productValidationsMap;
  };

  const checkValidation = () => {
    let newValidationState = getInitialState();
    if (
      validateSetupLimitInputFieldsOnClickNext(
        products,
        newCycle,
        newValidationState,
        translate
      )
    ) {
      goNextState();
    } else {
      setProductValidations(newValidationState);
    }
  };

  const handleProductLimitChange = (action, productID, limit) => {
    let updateValidationState = productValidations;
    //to remove the alert while user inputs again to make it non empty or valid
    if (
      removeInvalidMessageOnSetupLimitInputFieldChange(
        productID,
        updateValidationState
      )
    ) {
      setProductValidations(updateValidationState);
    }
    saveNewCycleData(action, {
      productID,
      limit,
    });
  };

  const renderButtonForNavigation = () => {
    return (
      <>
        <Button type="primary" onClick={checkValidation}>
          {translate("fundingLimit.button_next")}
        </Button>
      </>
    );
  };

  const renderPageContent = () => {
    return (
      <>
        {products.map((product) => {
          const productValue = newCycle[product.code];
          return (
            <SetupLimitCard
              key={product.code}
              cardData={product}
              cardValue={productValue.product_limit_snapshot}
              handleProductLimitChange={handleProductLimitChange}
              translate={translate}
              isInvalidInput={
                productValidations.has(product.code)
                  ? productValidations.get(product.code).isInvalidInput
                  : false
              }
              invalidInputMessage={
                productValidations.has(product.code)
                  ? productValidations.get(product.code).invalidInputMessage
                  : ""
              }
            />
          );
        })}
      </>
    );
  };

  if (loading) {
    return <Spin tip={translate("generic.loadingData")} size="large" />;
  } else {
    return (
      <>
        <div className="setup-limit-container">{renderPageContent()}</div>
        {renderButtonForNavigation()}
      </>
    );
  }
};

const mapStateToProps = ({
  localize,
  funding: { action, products, newCycle },
}) => ({
  translate: getTranslate(localize),
  action,
  products,
  newCycle,
  loading: isBusy(getProductsList),
});

const mapDispatchToProps = (dispatch) => bindActionCreators({ push }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withActions({ getProductsList, saveNewCycleData })(SetupLimit));
